import React from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { MenuItem, Select } from '@mui/material';
import { WithdrawPayload } from '@monorepo/client-types';
import { Stack, Typography } from '@monorepo/nova-ui';
import { PaymentMethod } from '@monorepo/types';

interface PaymentMethodsSectionProps {
  form: UseFormReturn<WithdrawPayload>;
  payoutOptions: Array<{ value: PaymentMethod; label: string }>;
}

export const PaymentMethodsSection: React.FC<PaymentMethodsSectionProps> = ({
  form,
  payoutOptions,
}) => {
  const { t } = useTranslation(['withdrawFundsNova']);
  return (
    <Stack direction={'column'} gap={2}>
      <Typography>{t('withdrawFundsNova:profit_share')}</Typography>
      <Controller
        rules={{ required: true }}
        name={'paymentOption'}
        control={form.control}
        render={({ field }) => (
          <Select
            {...field}
            value={field.value || ''}
            displayEmpty
            sx={{
              borderRadius: 4,
            }}
          >
            <MenuItem value="" disabled>
              {t('withdrawFundsNova:select_payment_method')}
            </MenuItem>
            {payoutOptions.map((option, index) => (
              <MenuItem key={index} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        )}
      />
    </Stack>
  );
};
